import * as tslib_1 from "tslib";
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
var UserinfoService = /** @class */ (function () {
    function UserinfoService(http) {
        this.http = http;
        console.log('[UserinfoService] constructor called');
        this.baseUrl = "" + environment.apiHost;
        this.path = '/makpak/userinfo';
        // Load cached user info if present to avoid null on refresh
        try {
            var cached = sessionStorage.getItem('USERINFO_CACHE');
            if (cached) {
                this.userinfo = JSON.parse(cached);
                console.log('[UserinfoService] loaded userinfo from cache');
            }
        }
        catch (e) {
            console.warn('[UserinfoService] failed to parse userinfo cache', e);
        }
    }
    UserinfoService.prototype.loadUserInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tokenPresent, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('[UserinfoService] loadUserInfo invoked; pathname=', window.location.pathname);
                        tokenPresent = !!sessionStorage.getItem('LOGIN_TOKEN');
                        if (window.location.pathname.includes('/auth/cim') && !tokenPresent) {
                            console.log('[UserinfoService] callback route without token yet - returning cached userinfo');
                            return [2 /*return*/, this.userinfo];
                        }
                        return [4 /*yield*/, this.http.get(this.baseUrl + this.path).toPromise()];
                    case 1:
                        response = _a.sent();
                        console.log('resounce from backend: ', response);
                        this.userinfo = JSON.parse(JSON.stringify(response));
                        console.log('userdata: ', this.userinfo);
                        try {
                            sessionStorage.setItem('USERINFO_CACHE', JSON.stringify(this.userinfo));
                        }
                        catch (_b) { }
                        return [2 /*return*/, this.userinfo];
                }
            });
        });
    };
    UserinfoService.prototype.getUserinfo = function () {
        return this.userinfo;
    };
    UserinfoService.prototype.setUserinfo = function (user) {
        this.userinfo = user;
    };
    return UserinfoService;
}());
export { UserinfoService };
